export default __webpack_public_path__ + "static/media/DSC_7525.47b578f2.jpg";